<script setup lang="ts">
export interface StoryblokUiPageListProps {
    blok: StoryblokUiPageList;
    inverted?: boolean;
}

// PROPS
const { blok, inverted = false } = defineProps<StoryblokUiPageListProps>();

// DATA
const ui = computed(() =>
    inverted
        ? {
              base: '**:text-inverted',
          }
        : {}
);
</script>

<template>
    <UPageList v-editable="blok" :divide="blok.divide" :ui="ui">
        <template v-if="blok.items?.length" #default>
            <StoryblokComponent v-for="i in blok.items" :key="i._uid" :blok="i" />
        </template>
    </UPageList>
</template>
